import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SceneService } from 'src/app/scenes/services/scene.service';
import { SceneDefinition } from 'src/app/scenes/models/scene-definition';
import {
    ConfirmationDialogComponent,
    ConfirmationDialogData,
} from 'src/app/shared/components/confirmation-modal/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SceneStateService } from 'src/app/scenes/services/scene-state.service';
import { ToastMessageService } from 'src/app/shared/services/toast-message.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-scene-import',
    templateUrl: './scene-import.component.html',
    styleUrls: ['./scene-import.component.scss'],
    standalone: false,
})
export class SceneImportComponent implements OnInit, OnChanges {
    @Input() trainingId: string;
    @Input() editingIsDisabled: boolean;
    @Input() robotId: string;

    sceneDefinitions: SceneDefinition[];
    dataLoaded: boolean = true;
    importSceneForm: FormGroup = new FormGroup({
        dropdownControl: new FormControl(null),
    });

    constructor(
        private sceneService: SceneService,
        private dialog: MatDialog,
        private sceneStateService: SceneStateService,
        private toastService: ToastMessageService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.sceneService
            .getSceneDefinitions(this.robotId)
            .subscribe((sceneDefinitions: SceneDefinition[]) => {
                this.sceneDefinitions = sceneDefinitions;
                this.dataLoaded = true;
                if (this.sceneDefinitions.length === 0) {
                    this.importSceneForm.disable();
                }
            });
    }

    setSelectedSceneDefinition(definitionName: string) {
        this.importSceneForm.get('dropdownControl').setValue(definitionName);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.editingIsDisabled &&
            !changes.editingIsDisabled.isFirstChange()
        ) {
            if (this.editingIsDisabled) {
                this.importSceneForm.disable();
            } else {
                this.importSceneForm.enable();
            }
        }
    }

    openImportDialog() {
        this.dialog
            .open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(
                ConfirmationDialogComponent,
                {
                    data: {
                        headerTranslationKey:
                            'scenes.components.sceneImport.importDialog.header',
                        confirmationQuestion: {
                            translationKey:
                                'scenes.components.sceneImport.importDialog.question',
                        },
                        confirmButtonTranslationKey:
                            'scenes.components.sceneImport.importDialog.confirm',
                        rejectButtonTranslationKey:
                            'scenes.components.sceneImport.importDialog.reject',
                        transferData: true,
                    } as ConfirmationDialogData,
                    width: '550px',
                }
            )
            .afterClosed()
            .subscribe((transferData) => {
                if (transferData) {
                    this.importScene();
                }
            });
    }

    importScene() {
        this.sceneStateService.isLoading$.next(true);
        this.sceneService
            .importScene(
                this.trainingId,
                this.sceneDefinitions.find(
                    (definition) =>
                        definition.name ===
                        this.importSceneForm.get('dropdownControl').value
                ).id
            )
            .subscribe({
                next: (scene) => {
                    this.sceneStateService.scene$.next(scene);
                    this.sceneStateService.isLoading$.next(false);
                },
                error: (_) => {
                    this.sceneStateService.isLoading$.next(false);
                    this.toastService.showErrorMsg(
                        this.translateService.instant(
                            'scenes.components.sceneImport.importDialog.error'
                        )
                    );
                },
            });
    }
}
